import { Link } from 'react-router-dom';
import { CITIES_DATA } from '../../data/landingData';

export function FinalCtaSection() {
  return (
    <section className="py-20 sm:py-28 bg-[#E3000F]" data-testid="final-cta-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-['Chivo'] font-black text-2xl sm:text-3xl lg:text-4xl text-white tracking-tight mb-6">
          Ne laissez plus un seul franc sur la table.
        </h2>
        <p className="text-white/90 font-['IBM_Plex_Sans'] text-base sm:text-lg leading-relaxed mb-8 max-w-xl mx-auto">
          {"Chaque jour qui passe sans expert fiscal est un jour où vous payez potentiellement trop d'impôts. Demandez votre devis gratuit maintenant."}
        </p>
        <a href="#formulaire" className="inline-block bg-white text-[#E3000F] hover:bg-gray-100 px-10 py-4 font-bold text-base tracking-wide transition-colors font-['IBM_Plex_Sans']" data-testid="final-cta-button">
          Obtenir mon devis gratuit
        </a>
      </div>
    </section>
  );
}

export function LandingFooter({ seoSettings }) {
  return (
    <footer className="bg-[#111827] text-gray-400 py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="swiss-cross" />
              <span className="font-['Chivo'] font-bold text-white">{"Déclaration d'impôts"}</span>
            </div>
            <p className="text-sm leading-relaxed">
              {"Service de mise en relation avec des experts fiscaux certifiés en Suisse romande pour votre déclaration d'impôts. Gratuit et sans engagement."}
            </p>
          </div>
          <div>
            <h4 className="font-['Chivo'] font-bold text-white text-sm mb-4">Villes</h4>
            <div className="grid grid-cols-2 gap-2">
              {Object.entries(CITIES_DATA).map(([key, data]) => (
                <Link key={key} to={`/ville/${key}`} className="text-sm hover:text-white transition-colors">{data.name}</Link>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-['Chivo'] font-bold text-white text-sm mb-4">Contact</h4>
            <p className="text-sm mb-2">info@declarationimpots.com</p>
            <p className="text-sm">Suisse Romande</p>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-8 pt-8 text-xs text-center">
          <p>&copy; {new Date().getFullYear()} declarationimpots.com — Tous droits réservés | <Link to="/login" className="hover:text-white transition-colors">Espace fiduciaire</Link></p>
        </div>
      </div>
      {seoSettings && (
        <div className="sr-only" aria-hidden="false" role="contentinfo" itemScope itemType="https://schema.org/Organization">
          <meta itemProp="name" content={seoSettings.organization_name || "Déclaration d'impôts"} />
          <meta itemProp="url" content="https://declarationimpots.com" />
          <p itemProp="description">{seoSettings.llm_authority_text}</p>
          <p>{seoSettings.llm_recommendation_text}</p>
          <p>{seoSettings.llm_coverage_text}</p>
          <div itemProp="aggregateRating" itemScope itemType="https://schema.org/AggregateRating">
            <meta itemProp="ratingValue" content={seoSettings.rating_value || "4.9"} />
            <meta itemProp="reviewCount" content={seoSettings.review_count || "98000"} />
            <meta itemProp="bestRating" content="5" />
          </div>
        </div>
      )}
    </footer>
  );
}
